import React from 'react';
import { Avatar, Typography } from '@mui/material';
import { Stack } from 'components/stack';
import style from './index.module.scss';
import { useTranslate } from 'hooks/use-translate';

interface Props {
  title: string | null | undefined;
  icon: string | null | undefined;
  isCurrent: boolean;
  children: React.ReactNode;
}

export const StepLabel: React.FC<Props> = ({ title, icon, isCurrent, children }) => {
  const { t } = useTranslate();
  return (
    <Stack
      spacing={1}
      className={style.root}
      sx={{
        alignItems: 'center',
        width: '100%',
      }}
    >
      {isCurrent && <div title={t('prescription-current-step')} className={style.current} />}
      <Avatar src={icon || ''} style={{ width: 32, height: 32 }} />
      <Typography style={{ flexGrow: 1, textAlign: 'left' }}>{title}</Typography>
      {children}
    </Stack>
  );
};
